import {
  SolutionPuposesEnum,
  SolutionTypesEnum,
  SolutionCategoriesEnum,
} from '../models/selectOptionsModels';

export const SOLUTION_PURPOSES_LIST: SolutionPuposesEnum[] = [
  SolutionPuposesEnum.BUSINESS_CONTINUITY,
  SolutionPuposesEnum.COMPLIANCE,
  SolutionPuposesEnum.COST_SAVINGS,
  SolutionPuposesEnum.GROWTH,
  SolutionPuposesEnum.LIFE_CYCLE,
  SolutionPuposesEnum.SUSTAINABILITY,
];

export const SOLUTION_TYPES_LIST: SolutionTypesEnum[] = [
  SolutionTypesEnum.ADAPTIVE_SCHEDULING_AND_OPTIMIZATON,
  SolutionTypesEnum.BMS_UPGRADE,
  SolutionTypesEnum.COMMERCIAL_REPAIRS,
  SolutionTypesEnum.ECOPILOT,
  SolutionTypesEnum.ENERGY_EFFICIENCY,
  SolutionTypesEnum.ENERGY_ENVELOPE_DOORS,
  SolutionTypesEnum.ENERGY_ENVELOPE_FACADE,
  SolutionTypesEnum.ENERGY_ENVELOPE_ROOF,
  SolutionTypesEnum.EV_CHARGERS,
  SolutionTypesEnum.FACADE_REPAIRS,
  SolutionTypesEnum.FLOORING_REPAIRS,
  SolutionTypesEnum.FUEL_CEIL,
  SolutionTypesEnum.GENERATORS,
  SolutionTypesEnum.HVAC,
  SolutionTypesEnum.LED,
  SolutionTypesEnum.LEGAL_OR_CONTRACTUAL,
  SolutionTypesEnum.LIGHTING_NON_LED,
  SolutionTypesEnum.METERING,
  SolutionTypesEnum.PARKING_REPAIRS,
  SolutionTypesEnum.POWER_OPTIMISER_E_POWER,
  SolutionTypesEnum.PUBLIC_INFRASTRUCTURE_INTERVENTION,
  SolutionTypesEnum.PV,
  SolutionTypesEnum.RESTROOMS,
  SolutionTypesEnum.RHC,
  SolutionTypesEnum.ROOF_REPAIRS,
  SolutionTypesEnum.SAFETY_AND_SECURITY,
  SolutionTypesEnum.STRUCTURAL_UPGRADES_AND_REPAIRS,
  SolutionTypesEnum.TECHNICAL_SYSTEMS_AND_EQUIPMENT_REPLACEMENTS_UPGRADES_AND_REPAIRS,
  SolutionTypesEnum.TRADE_DRESS_REPLACEMENT,
  SolutionTypesEnum.WASTE_BALERS,
  SolutionTypesEnum.WASTE_OTHER,
  SolutionTypesEnum.WASTE_WATER_MANAGEMENT,
  SolutionTypesEnum.WATER_RELATED_SYSTEMS,
];

export const SOLUTION_TYPES_LIST_COMMERCIAL: SolutionTypesEnum[] = [
  SolutionTypesEnum.CASH_LINE,
  SolutionTypesEnum.COMMERCIAL_EXTENSION,
  SolutionTypesEnum.COMMERCIAL_USE,
  SolutionTypesEnum.CO_WORKER_RESTAURANT_AREA,
  SolutionTypesEnum.CO_WORKER_SPACES,
  SolutionTypesEnum.CUSTOMER_SERVICES_CLICK_AND_COLLECT,
  SolutionTypesEnum.CUSTOMER_SERVICES_OTHER,
  SolutionTypesEnum.ENTRANCE,
  SolutionTypesEnum.EXIT,
  SolutionTypesEnum.FULL_COMMERCIAL_REBUILD,
  SolutionTypesEnum.KITCHEN_AND_DINING,
  SolutionTypesEnum.MARKET_HALL,
  SolutionTypesEnum.OTHER_COMMERCIAL_SOLUTION,
  SolutionTypesEnum.OTHER_FOOD_SOLUTION,
  SolutionTypesEnum.SHOW_ROOM,
  SolutionTypesEnum.SPACE_OPT,
  SolutionTypesEnum.SWEDISH_BISTRO,
  SolutionTypesEnum.SWEDISH_BITE,
  SolutionTypesEnum.SWEDISH_CAFE,
  SolutionTypesEnum.SWEDISH_DELI,
  SolutionTypesEnum.SWEDISH_FOOD_MARKET,
  SolutionTypesEnum.SWEDISH_RESTAURANT,
  SolutionTypesEnum.SWEDISH_SNACKS,
  SolutionTypesEnum.ZERO_EMISSION_CO_WORKER_AND_CUSTOMER_CHARGING,
];

export const SOLUTION_TYPES_LIST_CONCEPT: SolutionTypesEnum[] = [
  SolutionTypesEnum.CONCRETE_FLOORING,
  SolutionTypesEnum.IN_STORE_NAVIGATION,
  SolutionTypesEnum.OTHER_CONCEPTUAL_SOLUTION,
  SolutionTypesEnum.PARKING_AREAS,
  SolutionTypesEnum.TRADE_DRESS,
];

export const SOLUTION_TYPES_LIST_DIGITAL: SolutionTypesEnum[] = [
  SolutionTypesEnum.CHECKOUT_POS,
  SolutionTypesEnum.HOSTING,
  SolutionTypesEnum.LAN,
  SolutionTypesEnum.WAN,
  SolutionTypesEnum.WIFI,
];

export const SOLUTION_TYPES_LIST_FULFILMENT_AND_REPLENISHMENT: SolutionTypesEnum[] =
  [
    SolutionTypesEnum.AUTOMATION_HIGH,
    SolutionTypesEnum.AUTOMATION_MEDIUM,
    SolutionTypesEnum.CONVENTIONAL_WAREHOUSE_RACKING,
    SolutionTypesEnum.DC_FIT_FOR_FUTURE,
    SolutionTypesEnum.EXTENSION,
    SolutionTypesEnum.REDESIGN_STEP_1_OTHER,
    SolutionTypesEnum.REDESIGN_STEP_1_VASS,
    SolutionTypesEnum.REDESIGN_STEP_2,
    SolutionTypesEnum.REDESIGN_STEP_3_CLICK_AND_COLLECT_LOCKERS,
    SolutionTypesEnum.REDESIGN_STEP_3_COSS,
    SolutionTypesEnum.REDESIGN_STEP_3_LAYOUT,
    SolutionTypesEnum.REDESIGN_STEP_4,
    SolutionTypesEnum.REDESIGN_STEP_5,
    SolutionTypesEnum.REDESIGN_STEP_6,
    SolutionTypesEnum.REPLENISHMENT_CAPABILITIES,
    SolutionTypesEnum.ZERO_EMISSION_HDT_CHARGERS,
    SolutionTypesEnum.ZERO_EMISSION_LAST_MILE_DELIVERY_CHARGING,
    SolutionTypesEnum.ZERO_EMISSION_LAST_MILE_DELIVERY_FLEET,
    SolutionTypesEnum.OTHER_FULFILMENT_AND_REPLENISHMENT,
  ];

export const SOLUTION_TYPES_LIST_REAL_ESTATE: SolutionTypesEnum[] = [
  SolutionTypesEnum.ADAPTIVE_SCHEDULING_AND_OPTIMIZATON,
  SolutionTypesEnum.BMS_UPGRADE,
  SolutionTypesEnum.COMMERCIAL_REPAIRS,
  SolutionTypesEnum.ECOPILOT,
  SolutionTypesEnum.ENERGY_EFFICIENCY,
  SolutionTypesEnum.ENERGY_ENVELOPE_DOORS,
  SolutionTypesEnum.ENERGY_ENVELOPE_FACADE,
  SolutionTypesEnum.ENERGY_ENVELOPE_ROOF,
  SolutionTypesEnum.EQUIPMENT_REPLACEMENT_OR_UPGRADE,
  SolutionTypesEnum.EV_CHARGERS,
  SolutionTypesEnum.FACADE_REPAIRS,
  SolutionTypesEnum.FLOORING_REPAIRS,
  SolutionTypesEnum.FUEL_CEIL,
  SolutionTypesEnum.GENERATORS,
  SolutionTypesEnum.HVAC,
  SolutionTypesEnum.LED,
  SolutionTypesEnum.LEGAL_OR_CONTRACTUAL,
  SolutionTypesEnum.LIGHTNING_NON_LED,
  SolutionTypesEnum.METERING,
  SolutionTypesEnum.PARKING_REPAIRS,
  SolutionTypesEnum.PHOTOVOLTAIC_PANELS,
  SolutionTypesEnum.POWER_OPTIMISER_E_POWER,
  SolutionTypesEnum.PUBLIC_INFRASTRUCTURE_INTERVENTION,
  SolutionTypesEnum.RESTROOMS,
  SolutionTypesEnum.RHC,
  SolutionTypesEnum.ROOF_REPAIRS,
  SolutionTypesEnum.SAFETY_AND_SECURITY,
  SolutionTypesEnum.STRUCTURAL_UPGRADES_AND_REPAIRS,
  SolutionTypesEnum.TRADE_DRESS_REPLACEMENT,
  SolutionTypesEnum.WASTE_BALER,
  SolutionTypesEnum.WASTE_OTHER,
  SolutionTypesEnum.WASTE_WATER_MANAGEMENT,
  SolutionTypesEnum.WATER_RELATED_SYSTEMS,
];

export const SOLUTION_TYPES_LIST_SPACE_OPTIMIZATION_WITH_3RD_PARTIES = [
  SolutionTypesEnum.GO_DARK,
  SolutionTypesEnum.OPTIMISATION_OF_BUILDING_PREMISE_WITH_3RD_PARTY,
  SolutionTypesEnum.OPTIMISATION_OF_PARKING_LAND_WITH_3RD_PARTY,
];

export const SOLUTION_CATEGORIES_LIST: SolutionCategoriesEnum[] = [
  SolutionCategoriesEnum.COMMERCIAL_AND_COWORKER_AREAS,
  SolutionCategoriesEnum.CONCEPT,
  SolutionCategoriesEnum.DIGITAL_TECHNOLOGY,
  SolutionCategoriesEnum.FULFILMENT_AND_REPLENISHMENT,
  SolutionCategoriesEnum.REAL_ESTATE,
  SolutionCategoriesEnum.SPACE_OPTIMIZATION_WITH_3RD_PARTIES,
  SolutionCategoriesEnum.ASSET_LIFECYCLE_AND_COMPLIANCE,
  SolutionCategoriesEnum.ENERGY_WATER_WASTE_MANAGEMENT,
];

export const SOLUTION_CATEGORY_TYPE_DICTIONARY = {
  [SolutionCategoriesEnum.COMMERCIAL_AND_COWORKER_AREAS]:
    SOLUTION_TYPES_LIST_COMMERCIAL,
  [SolutionCategoriesEnum.CONCEPT]: SOLUTION_TYPES_LIST_CONCEPT,
  [SolutionCategoriesEnum.DIGITAL_TECHNOLOGY]: SOLUTION_TYPES_LIST_DIGITAL,
  [SolutionCategoriesEnum.FULFILMENT_AND_REPLENISHMENT]:
    SOLUTION_TYPES_LIST_FULFILMENT_AND_REPLENISHMENT,
  [SolutionCategoriesEnum.REAL_ESTATE]: SOLUTION_TYPES_LIST_REAL_ESTATE,
  [SolutionCategoriesEnum.ASSET_LIFECYCLE_AND_COMPLIANCE]:
    SOLUTION_TYPES_LIST_REAL_ESTATE,
  [SolutionCategoriesEnum.ENERGY_WATER_WASTE_MANAGEMENT]:
    SOLUTION_TYPES_LIST_REAL_ESTATE,
  [SolutionCategoriesEnum.SPACE_OPTIMIZATION_WITH_3RD_PARTIES]:
    SOLUTION_TYPES_LIST_SPACE_OPTIMIZATION_WITH_3RD_PARTIES,
};
